import React from 'react';
import Icon from '../../../components/AppIcon';
import Card from '../../../components/ui/Card';

const CenterMetrics = ({ centers }) => {
  const totalCenters = centers?.length || 0;
  const activeCenters = centers?.filter((c) => c?.isActive)?.length || 0;
  const totalSqft = centers?.reduce((sum, c) => sum + (Number(c?.totalSqft) || 0), 0);
  const totalSeats = centers?.reduce((sum, c) => sum + (Number(c?.totalSeats) || 0), 0);
  const occupiedSeats = centers?.reduce((sum, c) => sum + (Number(c?.occupiedSeats) || 0), 0);
  const avgBreakEven = totalCenters > 0
    ? centers?.reduce((sum, c) => sum + (Number(c?.breakEvenPercentage) || 0), 0) / totalCenters
    : 0;

  const metrics = [
    {
      label: 'Total Centers',
      value: totalCenters,
      icon: 'Building2',
      color: 'text-blue-600',
      bgColor: 'bg-blue-100',
    },
    {
      label: 'Active Centers',
      value: activeCenters,
      icon: 'CheckCircle',
      color: 'text-green-600',
      bgColor: 'bg-green-100',
    },
    {
      label: 'Total Sqft',
      value: new Intl.NumberFormat('en-IN')?.format(totalSqft),
      icon: 'Maximize',
      color: 'text-purple-600',
      bgColor: 'bg-purple-100',
    },
    {
      label: 'Total Seats',
      value: new Intl.NumberFormat('en-IN')?.format(totalSeats),
      icon: 'Users',
      color: 'text-orange-600',
      bgColor: 'bg-orange-100',
    },
    {
      label: 'Occupied Seats',
      value: new Intl.NumberFormat('en-IN')?.format(occupiedSeats),
      icon: 'UserCheck',
      color: 'text-teal-600',
      bgColor: 'bg-teal-100',
    },
    {
      label: 'Avg Break-Even %',
      value: `${avgBreakEven?.toFixed(1)}%`,
      icon: 'TrendingUp',
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-100',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      {metrics?.map((metric) => (
        <Card key={metric?.label} className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 mb-1">{metric?.label}</p>
              <p className="text-2xl font-bold text-gray-900">{metric?.value}</p>
            </div>
            <div className={`w-12 h-12 rounded-full ${metric?.bgColor} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default CenterMetrics;